import { Minus } from "lucide-react";
import { useLanguage } from "@/LanguageContext";
import { Asterisk, ChapterLabel, MaskedLine, Reveal, Segments } from "@/components/Reveal";

const Manifesto = () => {
  const { t } = useLanguage();
  const m = t.manifesto;

  return (
    <section id="valore" className="border-b border-noom-line bg-noom-paper" data-testid="section-problem-manifesto">
      <div className="mx-auto max-w-[1600px] px-6 py-24 lg:px-16 lg:py-36">
        <ChapterLabel testId="manifesto-label">{m.label}</ChapterLabel>
        <h2 className="mt-6 max-w-5xl font-display text-4xl font-semibold leading-[1.02] tracking-[-0.02em] text-noom-ink sm:text-5xl lg:text-6xl">
          {m.lines.map((line, i) => (
            <MaskedLine key={i} inView delay={i * 0.12}>
              <Segments segments={line} />
            </MaskedLine>
          ))}
        </h2>

        <div className="mt-16 grid gap-12 lg:grid-cols-2 lg:gap-16">
          <div>
            <Reveal>
              <p className="max-w-xl text-base leading-relaxed text-noom-muted sm:text-lg" data-testid="manifesto-body">
                {m.body}
              </p>
            </Reveal>
            <Reveal delay={0.12}>
              <p className="mt-6 max-w-xl text-base leading-relaxed text-noom-muted sm:text-lg">{m.body2}</p>
            </Reveal>
            <Reveal delay={0.2}>
              <blockquote
                data-testid="problem-quote"
                className="mt-12 border-l-2 border-noom-lilac bg-white p-8 font-display text-xl font-medium leading-snug tracking-tight text-noom-ink sm:text-2xl"
              >
                {m.quote}
              </blockquote>
            </Reveal>
          </div>

          <div className="flex flex-col gap-6">
            <Reveal delay={0.1}>
              <div
                data-testid="problem-before-list"
                className="border border-noom-line bg-white p-8 transition-transform duration-500 ease-noom hover:-translate-y-1"
              >
                <p className="font-mono text-[11px] uppercase tracking-[0.25em] text-noom-faint">{m.before.title}</p>
                <ul className="mt-6 space-y-4">
                  {m.before.items.map((item, i) => (
                    <li key={i} className="flex items-start gap-3 text-sm leading-relaxed text-noom-muted sm:text-base">
                      <Minus className="mt-1 h-4 w-4 shrink-0 text-noom-faint" />
                      {item}
                    </li>
                  ))}
                </ul>
              </div>
            </Reveal>
            <Reveal delay={0.22}>
              <div
                data-testid="problem-after-list"
                className="bg-noom-ink p-8 text-white transition-transform duration-500 ease-noom hover:-translate-y-1"
              >
                <p className="font-mono text-[11px] uppercase tracking-[0.25em] text-noom-lilac">{m.after.title}</p>
                <ul className="mt-6 space-y-4">
                  {m.after.items.map((item, i) => (
                    <li key={i} className="flex items-start gap-3 text-sm leading-relaxed text-white/85 sm:text-base">
                      <Asterisk className="mt-1 h-3.5 w-3.5 shrink-0 text-noom-lilac" />
                      {item}
                    </li>
                  ))}
                </ul>
              </div>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Manifesto;
